import { useState, useCallback } from 'react';
import { Copy, Check } from 'lucide-react';

interface CopyableFieldProps {
  value: string | number;
  className?: string;
  mono?: boolean;
}

export function CopyableField({ value, className = '', mono = false }: CopyableFieldProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const textArea = document.createElement('textarea');
      textArea.value = String(value);
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [value]);

  return (
    <span className={`inline-flex items-center gap-1 group ${className}`}>
      <span className={mono ? 'font-mono' : ''}>{value}</span>
      <button
        onClick={handleCopy}
        className="opacity-0 group-hover:opacity-100 transition-opacity p-0.5 rounded hover:bg-background-muted"
        title={copied ? 'Copied!' : 'Copy to clipboard'}
        aria-label={`Copy ${value}`}
      >
        {copied ? (
          <Check className="h-3 w-3 text-success" />
        ) : (
          <Copy className="h-3 w-3 text-foreground-muted" />
        )}
      </button>
    </span>
  );
}
